import { render, staticRenderFns } from "./devices-card.vue?vue&type=template&id=24b2c6d8&scoped=true&"
import script from "./devices-card.vue?vue&type=script&lang=js&"
export * from "./devices-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b2c6d8",
  null
  
)

export default component.exports